export default "__VITE_ASSET__D8pD9nxi__"